<template>
  <div class="store_orderOnline">
    <div class="store_orderOnline-search">
      <div class="store_orderOnline-title">服务搜索</div>
      <input placeholder="搜索服务" v-model="keyword" @keydown.enter="handleClickKeyword" />
      <a target="_blank" :href="host.portalUrl + '/order-online?keyword=' + keyword"></a>
      <!-- <i @click="handleClickKeyword" :href="(host.portalUrl + '/order-online?keyword=' + keyword)"></i> -->
    </div>
    <div class="store_orderOnline-category">
      <div class="store_orderOnline-title">服务类别</div>
      <div>
        <dl v-for="lab of categorys" :key="lab.labelId">
          <dt> {{ lab.labelName }}</dt>
          <dd v-for="item of lab.children" :key='item.labelId'>
            <i></i>
            <a target="_blank"
              :href="host.portalUrl + '/order-online?categorys=' + item.parentLabelCode + '-' + item.labelCode">{{
    item.labelName
              }}</a>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { host } from 'src/config'
import { qryCategory } from './../../request/store'
import { createTreeData } from './../../utils'

export default {
  name: 'StoreOrderOnline',
  props: {
    env: {
      type: String,
      default: 'local',
    },
  },
  data() {
    return {
      host: host(this.env),
      keyword: '',
      categorys: []
    }
  },
  methods: {
    handleClickKeyword() {
      window.location.href = `${this.host.portalUrl}/order-online?keyword=${this.keyword}`
    }
  },
  mounted() {
    qryCategory({ labelName: '', labelType: '01' }, this.host.nodeUrl).then(res => {
      this.categorys = res.data.items
      // 为每个分类创建children标签
      this.categorys.map((v) => {
        v.children = []
      })
      // 格式化为树形结构数据
      this.categorys = createTreeData(
        this.categorys,
        'labelCode',
        'parentLabelCode'
      )
      // 隐藏没有子集的分类
      this.categorys = this.categorys.filter((v) => {
        return v.children.length
      })
    })
  },
}
</script>

<style lang='scss'>
@import './../../assets/style/mixin.scss';

.store_orderOnline {
  * {
    padding: 0;
    margin: 0;
  }

  width: 212px;
  border: 1px solid #ddd;

  .store_orderOnline-title {
    color: #878787;
    font-size: 12px;
    padding: 14px 0;
  }

  .store_orderOnline-search {
    width: 204px;
    background: #E8E8E8;
    position: relative;
    padding-left: 8px;
    padding-bottom: 13px;

    input {
      height: 34px;
      line-height: 34px;
      width: 184px;
      background: #fff;
      font-size: 12px;
      color: #878787;
      border: 1px solid #E8E8E8;
      outline: none;
      padding-left: 7px;

      &:focus {
        border: 1px solid #E8E8E8;

      }
    }

    a {
      display: block;
      width: 14px;
      height: 14px;
      background: url('./../../assets/images/store/orderOnline/search.png');
      position: absolute;
      right: 16px;
      bottom: 23px;
      z-index: 2;
    }
  }

  .store_orderOnline-category {
    width: 196px;
    // padding: 0 8px;
    padding-left: 8px;

    dl {
      color: #333;
      border-bottom: 1px dashed #C8C8C8;
      padding-bottom: 10px;
      padding-top: 10px;

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        border-bottom: 0;
      }
    }

    dt {
      font-size: 14px;
      font-weight: bold;
      padding-bottom: 5px;
    }

    dd {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: 25px;
      padding-left: 5px;

      i {
        background: $mainColor;
        width: 4px;
        height: 4px;
      }

      a {
        font-size: 12px;
        padding-left: 6px;
        width: 100%;
        overflow: hidden;
        height: 25px;
        color: #333;

        &:hover {
          color: $mainColor;
        }
      }
    }
  }
}
</style>